





















































import { Component } from 'vue-property-decorator';
import { ProductWizardModule } from '@/store/Products/ProductWizardModule';
import SaascadaVue from '@/components/Shared/SaascadaVue';
import LendingFeeDefinitionCreate from '@/components/Products/Forms/Lending/LendingFeeDefinitionCreate.vue';

@Component({ name: 'LendingFeeSettingsCreate', components: { LendingFeeDefinitionCreate } })
export default class extends SaascadaVue {

    headers = [
        { text: 'Type', value: 'type' },
        { text: 'Name', value: 'name' },
        { text: 'Description', value: 'description' },
        { text: 'Amount', value: 'amount' },
        { text: 'Override Amount?'},
        { text: 'Actions' },
    ]

    get productVM() {
        return ProductWizardModule.createProductViewModel;
    }

}
